export interface ILeaveOrganizationRoot {
  leaveOrganization: ILeaveOrganizationSlice;
}

export interface ILeaveOrganizationSlice {
  readonly hasSubmitLeaveOrg: boolean;
  readonly hasLeftOrg: boolean;
  readonly hasError: boolean;
  readonly phase: LeaveOrgPhase;
}

export enum LeaveOrgPhase {
  default = 'default',
  hasSubmitLeaveOrg = 'hasSubmitLeaveOrg',
  leaveOrgSuccess = 'leaveOrgSuccess',
  leaveOrgFailure = 'leaveOrgFailure'
}
